// type
import { NavItemType } from 'types/menu';
import { AppstoreAddOutlined, DollarOutlined, ProjectOutlined } from '@ant-design/icons';
const contractors: NavItemType = {
    id: 'group-contractors',
    title: 'Contractors',
    icon: AppstoreAddOutlined,
    type: 'group',
    children: [
        {
            id: 'contractor-masteragreement',
            title: 'Master Agreement',
            subtitle: 'Manage Master Agreement',
            type: 'item',
            url: '/apps/contractors/masteragreement',
            icon: ProjectOutlined,
            featureID: 24,
            breadcrumbs: false,
            visible: true
        },

        {
            id: 'contractor-masteragreement-viewer',
            title: 'Master Agreement',
            subtitle: 'Manage Master Agreement',
            type: 'item',
            url: '/apps/contractors/masteragreement/:masterAgreementID',
            icon: ProjectOutlined,
            featureID: 24,
            breadcrumbs: false,
            visible: false
        },

        {
            id: 'projects',
            title: 'Projects',
            subtitle: 'Manage Projects',
            type: 'item',
            url: '/apps/contractors/projects',
            icon: ProjectOutlined,
            featureID: 8,
        },
        {
            id: 'projects',
            title: 'Projects',
            subtitle: 'Manage Projects',
            type: 'item',
            url: '/apps/contractors/projects/workspace/:projectID',
            icon: ProjectOutlined,
            featureID: 8,
            breadcrumbs: false,
            visible: false
        },


        {
            id: 'invoices',
            title: 'Invoices',
            subtitle: 'View Invoices',
            type: 'item',
            url: '/apps/contractors/invoices',
            icon: ProjectOutlined,
            featureID: 29,
            breadcrumbs: false,
            visible: true

        },



        {
            id: 'credits',
            title: 'Credits',
            subtitle: 'View your available credits, usage, and expiration details.',
            type: 'item',
            url: '/apps/contractor/transactions/credits',
            icon: ProjectOutlined,
            featureID: 31,
        },
        {
            id: 'Subscriptions',
            title: 'Subscriptions',
            subtitle: 'View your current subscription and track past subscription history.',
            type: 'item',
            url: '/contractors/subscriptions',
            icon: DollarOutlined,
            featureID: 32,
        },

    ],
};

export default contractors;
